import { PATH_DASHBOARD } from "@app/routes/paths";

export const NAV = {
  W_DASHBOARD: 251,
  //
  H_DASHBOARD_ITEM: 48,
  H_DASHBOARD_ITEM_SUB: 36,
};
//----------------APP config----------------------

export const PATH_AFTER_LOGIN = PATH_DASHBOARD.dashboard;

//----------------API CONFIGS---------------------
export const BASE_URL = process.env.REACT_APP_BASE_URL ?? "";
export const API_TIMEOUT = process.env.REACT_APP_API_TIMEOUT ?? 0;
export const API_PREFIX = "/api/v1";

//---------------Header Title-------------------------


export enum UserRoles {
  ADMIN = "Admin",
  ESTIMATOR = "Estimator",
  DETAILER = "Detailer",
  FIELD_INSTALLER = "Field Installer",
  PURCHASER = "Purchaser",
  FAB_SHOP = "Fab Shop",
  WELDER = "Welder",
}

export enum ProjectStatus {
  INPROGRESS = "In Progress",
  COMPLETE = "Completed",
  PENDING = "pending",
  BUG = "Bug",
}

export enum SpoolStatus {
  NotDetailed = "Not Detailed",
  Detailed = "Detailed",
  InFabrication = "In Fabrication",
  Fabricated = "Fabricated",
  Shipped = "Shipped",
  pending = "Pending",
  Installed = "Installed",
}

export enum UserStatus {
  ACTIVE = "Active",
  INACTIVE = "Inactive",
}
